import { render } from "./BaseSidebar.vue?vue&type=template&id=49270a96&scoped=true"
import script from "./BaseSidebar.vue?vue&type=script&lang=js"
export * from "./BaseSidebar.vue?vue&type=script&lang=js"

import "./BaseSidebar.vue?vue&type=style&index=0&id=49270a96&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49270a96"]])

export default __exports__